"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchFilter = void 0;
function searchFilter(optionValue, inputValue) {
    return String(optionValue)
        .trim()
        .toLowerCase()
        .includes(String(inputValue)
        .trim()
        .toLowerCase());
}
exports.searchFilter = searchFilter;
//# sourceMappingURL=search-filter.js.map